import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { VideoInterface } from 'common/types/entities/VideoInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createVideo(
  parentId: string,
  masterBlockId?: MasterBlockId,
): VideoInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Video, parentId, masterBlockId),
    type: EntityTypeEnum.Video,
    url: 'https://youtu.be/f48bbvvDJFQ',
    border: {
      radius: 8,
    },
    controls: true,
  }
}
